exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.intl-tel-input[data-v-72b06223]{\r\n  position: relative;\n}\n.intl-tel-input.has-error input[data-v-72b06223]{\r\n  padding-right: 32px;\n}\n.intl-tel-input input[data-v-72b06223]{\r\n  z-index: 1;\n}\n.flag-container[data-v-72b06223]{\r\n  z-index: 2;\n}\n.input-overlay[data-v-72b06223]{\r\n  height: inherit;\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\n}\n.input-overlay > i[data-v-72b06223] {\r\n  font-size: 20px;\r\n  color: darkgray;\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 8px;\r\n  transform: translateY(-50%);\r\n  z-index: 1;\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-72b06223","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/tel-input.vue
// module id = 608
// module chunks = 0